import { render, staticRenderFns } from "./DigitalBusinessCardsConfig.vue?vue&type=template&id=27e556f6&"
import script from "./DigitalBusinessCardsConfig.vue?vue&type=script&lang=js&"
export * from "./DigitalBusinessCardsConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports